export default {"src":"/_next/static/media/companyName.a6501946.svg","height":19,"width":169,"blurWidth":0,"blurHeight":0};